<template>
	<v-flex
		xs12
		sm8
		md6
		lg4
	>
		<v-card class="elevation-12">
			<v-toolbar
				dark
				flat
				color="primary"
			>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				<v-spacer/>
				<v-avatar
					size="32px"
					tile
				>
					<img
						src="/logo.png"
						alt="Report Mule logo."
					>
				</v-avatar>
			</v-toolbar>
			<v-form
				v-show="!forgotPassword"
				ref="login"
				v-model="valid.login"
				@submit.prevent="submit"
			>
				<v-progress-linear
					v-if="loading"
					class="ma-0"
					indeterminate
				/>
				<v-card-text class="text-xs-center">
					<v-text-field
						style="display: none;"
						v-model="auth.turnstileToken"
						:rules="validate.require"
					/>
					<v-text-field
						v-model="auth.username"
						:rules="[...validate.require, validate.email]"
						:disabled="loading"
						placeholder=" "
						prepend-icon="person"
						name="username"
						label="Login"
						type="text"
					/>
					<v-text-field
						v-model="auth.password"
						:rules="validate.require"
						:disabled="loading"
						placeholder=" "
						prepend-icon="lock"
						name="password"
						label="Password"
						type="password"
					/>
				</v-card-text>
				<v-card-actions>
					<v-layout
						row
						wrap
						pa-1
					>
						<v-flex xs12>
							<v-checkbox
								v-model="rememberMe"
								:disabled="loading"
								hide-details
								name="remember"
								label="Remember Me"
								color="primary"
								class="pb-2"
							/>
						</v-flex>
						<v-flex xs12>
							<v-btn
								flat
								small
								depressed
								class="body-1"
								style="text-transform: capitalize; font-weight: normal;"
								:disabled="loading"
								@click.prevent="forgotPassword = !forgotPassword"
							>
								Forgot Password?
							</v-btn>
						</v-flex>
					</v-layout>
					<v-spacer/>
					<v-btn
						:disabled="!valid.login || loading"
						color="primary"
						type="submit"
						class="ma-2"
					>
						Log In
					</v-btn>
				</v-card-actions>
			</v-form>
			<v-form
				v-show="forgotPassword"
				v-model="valid.forgot"
				@submit.prevent="resetPassword"
			>
				<v-progress-linear
					v-if="loading"
					class="ma-0"
					indeterminate
				/>
				<v-card-text>
					<v-text-field
						style="display: none;"
						v-model="auth.turnstileToken"
						:rules="validate.require"
					/>
					<v-text-field
						v-model="auth.username"
						:rules="[validate.email]"
						:validate-on-blur="true"
						prepend-icon="person"
						name="email"
						label="Email"
						type="text"
					/>
				</v-card-text>
				<v-card-actions>
					<v-btn
						flat
						color="success"
						class="ma-2"
						@click="forgotPassword = !forgotPassword"
					>
						<v-icon>keyboard_return</v-icon>
						return
					</v-btn>
					<v-spacer/>
					<v-btn
						:disabled="!valid.forgot"
						type="submit"
						color="primary"
						class="ma-2"
					>
						request
					</v-btn>
				</v-card-actions>
			</v-form>
			<div class="cf-turnstile-wrapper">
				<div>
					<div id="cf-turnstile" />
				</div>
			</div>
		</v-card>
		<v-card
			v-show="!forgotPassword"
			class="elevation-12 mt-4"
		>
			<v-toolbar dark>
				<v-toolbar-title>New User?</v-toolbar-title>
				<v-spacer/>
				<v-btn
					:to="{ name: 'CreateAccount' }"
					:disabled="loading"
					flat
				>
					Create Account
				</v-btn>
			</v-toolbar>
		</v-card>
		<!-- <div class="mt-4">
			<p class="text-xs-center">
				Looking for the Classic version instead?<br>
				<v-btn flat small href="https://classic.reportmule.com/">Log In Here</v-btn>
			</p>
		</div> -->
		<v-bottom-sheet
			v-model="gdpr"
			persistent
			hide-overlay
			inset
		>
			<v-card tile class="primary white--text px-4 py-2">
				<v-layout row wrap justify-space-between align-center>
					<v-flex>
						<div class="subheading">
							Report Mule uses cookies to ensure you get the best experience.
						</div>
					</v-flex>
					<v-flex class="text-xs-right">
						<v-btn @click="acceptGDPR">Got It</v-btn>
					</v-flex>
				</v-layout>
			</v-card>
		</v-bottom-sheet>
	</v-flex>
</template>

<script>
import Validation from '@/mixins/Validation';
import { Login, GetReset } from '@/models/Login';

export default {
	mixins: [Validation],
	data() {
		return {
			valid: { login: true, forgot: true },
			rememberMe: true,
			forgotPassword: false,
			usernameReset: '',
			auth: {
				username: '',
				password: '',
				turnstileToken: '',
			},
			loading: false,
			gdpr: false,
			turnstileWidgetId: null,
		};
	},
	beforeMount() {
		if (window.turnstile === undefined || !window.turnstile) {
			this.$loadScript('https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback');
		}
	},
	mounted() {
		if (window.turnstile === undefined || !window.turnstile) {
			window.onloadTurnstileCallback = () => {
				this.renderTurnstile();
			};
		} else {
			this.renderTurnstile();
		}
	},
	beforeDestroy() {
		this.removeTurnstile();
	},
	computed: {
		title() {
			if (this.forgotPassword) {
				return 'Reset Password';
			}
			return 'Login';
		},
	},
	created() {
		if (this.$route.query.forgot) {
			this.forgotPassword = true;
		}
		if (!localStorage.getItem('gdpr')) {
			this.gdpr = true;
		}
	},
	methods: {
		submit() {
			this.loading = true;
			const login = new Login(this.auth);
			login.save().then((resp) => {
				this.loginSuccessful(resp.response);
			}).catch(() => {
				this.loginFailed();
			}).finally(() => {
				this.loading = false;
			});
		},
		// Similar logic is used for Create Account
		loginSuccessful(resp) {
			if (!resp.data.authKey) {
				this.loginFailed();
				return;
			}
			if (this.rememberMe) {
				localStorage.authKey = resp.data.authKey;
			}
			else {
				sessionStorage.authKey = resp.data.authKey;
			}
			// Add auth params to localStorage
			this.$ls.login(resp);
			this.$router.replace(this.$route.query.redirect || '/');
		},
		loginFailed() {
			this.auth.password = '';
			this.$notify('error', 'Login unsuccessful');
			delete localStorage.authKey;
		},
		resetPassword() {
			this.loading = true;
			const reset = new GetReset({ email: this.auth.username, turnstileToken: this.auth.turnstileToken });
			reset.save().then(() => {
				this.$notify('success', 'Please check your email to complete password reset.');
				this.forgotPassword = false;
			}).catch((error) => {
				this.$notify('error', error.response.response.data.message);
			}).finally(() => {
				this.loading = false;
			});
		},
		acceptGDPR() {
			localStorage.setItem('gdpr', true);
			this.gdpr = false;
		},
		renderTurnstile() {
			this.removeTurnstile();
			this.turnstileWidgetId = window.turnstile.render("#cf-turnstile", {
				sitekey: process.env.VUE_APP_CLOUDFLARE_TURNSTILE_SITE_KEY,
				callback: (token) => {
					this.auth.turnstileToken = token;
				},
			});
		},
		removeTurnstile() {
			if (this.turnstileWidgetId) {
				window.turnstile.remove(this.turnstileWidgetId);
				this.turnstileWidgetId = null;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
a {
	text-decoration: none;
}
.v-input--checkbox {
	margin: 0;
}
.cf-turnstile-wrapper {
	display: flex;
	justify-content: center;
	padding: 8px;
	> div {
		height: 65px;
		width: 300px;
	}
}
</style>
